import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import * as moment from "moment";
import { addAdminUser } from "../../services/admin.service";
import { ProductService } from "../../services/product.service";
import FileBase64 from "react-file-base64";
import ReactPlayer from "react-player";
import { PopUpPortal } from "../../containers/popups/PopUpPortal";



import $ from "jquery";
import {
  success,
  warning,
  successNotification,
  error,
  errorNotification,
  warningNotification
} from "../notification/notifications";
import { LoginService } from "../../services/login.service";
import { RegionManagementService } from "../../services/regionManagement.service";
import { RegisterUserService } from "../../services/registration.service";
import RestDataSource from "../../services/restdatasource";
import { Global_var } from "../../global/global_var";
import { fetchProductTypeData } from "../../services/fetchLearnerDashboard.service";

class EditProduct extends Component {
  constructor(props) {

    super(props);

    let todaydate = new Date();

    this.state = {
      products: "",
      productName: this.props.history.location.state.product.productName ? this.props.history.location.state.product.productName : "",
      productThumbnail: this.props.history.location.state.product.productThumbnail ? this.props.history.location.state.product.productThumbnail : (localStorage.getItem('prdthumbnail') ? localStorage.getItem('prdthumbnail') : ""),
      productLink: this.props.history.location.state.product.productLink ? this.props.history.location.state.product.productLink : "",
      partnerPartyID: this.props.history.location.state.product.partnerID ? this.props.history.location.state.product.partnerID : "",
      partner: "",

      isParentProduct: this.props.history.location.state.product.isParentProduct ? this.props.history.location.state.product.isParentProduct : "",
      parentProductID: this.props.history.location.state.product.parentProductID ? this.props.history.location.state.product.parentProductID : "",

      buid: this.props.history.location.state.product.buid ? this.props.history.location.state.product.buid : "",
      productAnchor: this.props.history.location.state.product.productAnchor ? this.props.history.location.state.product.productAnchor : "",
      productSubtitle: this.props.history.location.state.product.productSubtitle ? this.props.history.location.state.product.productSubtitle : "",
      productLanguage: this.props.history.location.state.product.productLanguage ? this.props.history.location.state.product.productLanguage : "",

      productDescription: this.props.history.location.state.product.productDescription ? this.props.history.location.state.product.productDescription : "",
      productTypeList: this.props.productType ? this.props.productType : "",
      partnerList: [],
      productType: this.props.history.location.state.product.productType ? this.props.history.location.state.product.productType : "",
      productCode: this.props.history.location.state.product.productCode ? this.props.history.location.state.product.productCode : "",
      productPrice: this.props.history.location.state.product.productPrice ? this.props.history.location.state.product.productPrice : "",
      isActive: this.props.history.location.state.product.isActive ? this.props.history.location.state.product.isActive : "",
      createdBy: this.props.history.location.state.product.createdBy ? this.props.history.location.state.product.createdBy : "",
      createdDate: this.props.history.location.state.product.createdDate ? this.props.history.location.state.product.createdDate : "",
      lastModifiedBy: this.props.history.location.state.product.lastModifiedBy ? this.props.history.location.state.product.lastModifiedBy : "",
      lastModifiedDate: this.props.history.location.state.product.lastModifiedDate ? this.props.history.location.state.product.lastModifiedDate : "",
      productMinPassingScore: this.props.history.location.state.product.productMinPassingScore ? this.props.history.location.state.product.productMinPassingScore : "",
      reAttemptPrice: this.props.history.location.state.product.productReattemptPrice ? this.props.history.location.state.product.productReattemptPrice : "",
      totalScore: this.props.history.location.state.product.totalScore ? this.props.history.location.state.product.totalScore : "",
      partnerID: this.props.history.location.state.product.partnerID ? this.props.history.location.state.product.partnerID : "",
      productID: this.props.history.location.state.product.productID ? this.props.history.location.state.product.productID : "",
      providerProductID: this.props.history.location.state.product.providerProductID ? this.props.history.location.state.product.providerProductID : "",
      productVideourl: this.props.history.location.state.product.productVideourl ? this.props.history.location.state.product.productVideourl : (localStorage.getItem('prdvideourl') ? localStorage.getItem('prdvideourl') : ""),
      role: '',
      status: '',
      statusList: this.props.status ? this.props.status : "",

      hasModules: this.props.history.location.state.product.hasModules ? this.props.history.location.state.product.hasModules : "",
      isOptional: this.props.history.location.state.product.isOptional ? this.props.history.location.state.product.isOptional : "",
      isDisplayinCourseCatalog: this.props.history.location.state.product.isDisplayinCourseCatalog ? this.props.history.location.state.product.isDisplayinCourseCatalog : "",
      loading: false,
      "autoplay": false,
    }
    //console.log('editproduct state data : ', this.state);
  }

  componentWillMount() {

    LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
    });

  }

  componentDidMount() {

    localStorage.getItem('productTypeedit') ?
      this.setState({
        productTypeList: JSON.parse(localStorage.getItem('productTypeedit'))
      }) : this.setState({
        productTypeList: this.props.productType
      });

    localStorage.getItem('statusedit') ?
      this.setState({
        statusList: JSON.parse(localStorage.getItem('statusedit'))
      }) : this.setState({
        statusList: this.props.status
      });

    this.setState({

    });
    //console.log("Props data ", this.props.fetchProductTypeData);
  }

  handleUpload = (ev) => {

    ev.document.forEach(element => {

      let data1 = {

        documentType: element.documentType,
        documentKey: localStorage.getItem("userid-Token"),
        documentName: element.documentName,
        replaceIfExists: "1",
        documentHash: element.documentHash,
        storageLocation: "AWS",
        partyId: localStorage.getItem("userid-Token"),
        buId: "2",
        bucketTag: "Dap-bucket-tag",
        documentTag: element.documentType
      }

      ProductService.addProductImageVideo(
        data1,
        cb => {


          if (cb.responseObject.documentType == "ProductThumbNail") {
            localStorage.setItem('prdthumbnail', cb.responseObject.documentPath);
          }
          if (cb.responseObject.documentType == "ProductVideourl") {
            localStorage.setItem('prdvideourl', cb.responseObject.documentPath);
          }
          //console.log("CB", cb.status);
          if (cb.status !== "success") {
            // error(cb.reasonText, {
            //   ...errorNotification,
            //   container: "top-center"
            // });
            warning(cb.reasonText, {
              ...warningNotification,
              container: "top-center"
            })
          }
        },
        err => console.log("Error", err)
      );
    });
  }
  handleCancel = () => {
    this.props.history.goBack('-1');
  };



  render() {
    const urls = (/^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)+$/);

    return (

      <Formik
        enableReinitialize={true}
        initialValues={{
          today: moment(new Date()).format("YYYY-MM-DD"),
          products: "",
          productType: this.props.history.location.state.product.productType,
          productName: this.state.productName,
          productThumbnail: this.state.productThumbnail,
          productLink: this.state.productLink,
          productAnchor: this.state.productAnchor,
          productSubtitle: this.state.productSubtitle,
          productLanguage: this.state.productLanguage,
          //productDescription: this.props.history.location.state.product.productDescription,
          productDescription: this.state.productDescription,

          productCode: this.state.productCode,
          productPrice: this.state.productPrice,
          productVideourl: this.state.productVideourl,

          partnerPartyID: this.state.partnerPartyID,
          partner: this.state.partnerID,
          isParentProduct: this.state.isParentProduct,
          parentProductID: this.state.parentProductID,
          // buid: this.state.buid,
          statusList: this.props.status,

          //   productTypeList: this.props.productLanguage,
          //   partnerList: this.props.partner,

          //productType: "",

          //isActive: "",
          createdBy: this.state.createdBy,
          createdDate: this.state.createdDate,
          lastModifiedBy: this.state.lastModifiedBy,
          lastModifiedDate: "",

          productMinPassingScore: this.state.productMinPassingScore,
          reAttemptPrice: this.state.reAttemptPrice,
          //  productReattemptPrice: values.reAttemptPrice,
          totalScore: this.state.totalScore,
          partnerID: this.state.partnerID,

          providerProductID: this.state.providerProductID,

          role: "",
          //status: this.state.isActive,
          //isActive: this.state.isActive,
          isActive: this.props.history.location.state.product.isActive,
          // statusList: this.state.statusList,
          hasModules: this.state.hasModules,
          isOptional: this.state.isOptional,
          isDisplayinCourseCatalog: this.state.isDisplayinCourseCatalog,
          document: [],
          checked: false
        }}

        validationSchema={Yup.object().shape({
          //static validations
          productType: Yup.string().required("You must specify a Product Type"),
          productName: Yup.string().required(" You must specify a Product Name"),
          productCode: Yup.string(),
          //productThumbnail: Yup.string().required("You must specify a Product Thumbnail"),
          // productLink: Yup.string().matches("(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})" , 'invalid url'),
          productLink: Yup.string().matches(urls, { message: "Enter valid url", excludeEmptyString: false }),

          //productVideourl: Yup.string().required("You must specify a VideoURL"),
          partner: Yup.string().required("You must specify a Partner"),
          productAnchor: Yup.string(),
          productSubtitle: Yup.string(),
          productLanguage: Yup.string(),
          productPrice: Yup.string().matches(
            /^[0-9]+\d$/,
            "Please provide valid product price"
          ).required("You must specify a product price"),
          productMinPassingScore: Yup.string().matches(
            /^[0-9]+\d$/,
            "Please provide valid minimum passing score"
          ),
          totalScore: Yup.string().matches(
            /^[0-9]+\d$/,
            "Please provide total score"
          ),
          isActive: Yup.string().required("You must specify a Product status"),
          reAttemptPrice: Yup.string().matches(
            /^[0-9]+\d$/,
            "Please provide valid reattempt price"
          ).required("You must specify a reattempt price"),
          //productDescription: Yup.string().required("Product Description  is required"),

          //  productID: Yup.string().required("Product ID  is required"),
          //  productPrice: Yup.string().required("ProductPrice  is required"),
          //  productLink: Yup.string().required("ProductLink  is required"),
          //  productAnchor: Yup.string().required("Product Anchor  is required"),
          //  productSubtitle: Yup.string().required("Product Subtitle  is required"),
          //   productLanguage: Yup.string().required("Product Language  is required"),
          //   providerProductID: Yup.string().required("Provider ProductID  is required"),
          //   productVideourl: Yup.string().required("Product VideoURL  is required"),
          //   status: Yup.string().required("Product VideoURL  is required"),
          //   productDescription: Yup.string().required("Product Description  is required"),



          // hasModules: Yup.bool()
          // .test(
          //   'hasModules',
          //   'You have to agree with our Terms and Conditions!',
          //   value => value === true
          // )
          // .required(
          //   'You have to agree with our Terms and Conditions!'
          // ),
          //   productType: Yup.lazy((values, key) => {
          //     switch (key.parent.role) {
          //         // case "Learner":
          //         default:
          //             return Yup.string().required("product Type is required");
          //         // default:
          //         //     return Yup.string();
          //     }
          // }),
          //   partner: Yup.lazy((values, key) => {
          //     switch (key.parent.role) {
          //         // case "Learner":
          //         default:
          //             return Yup.string().required("Partner is required");
          //         // default:
          //         //     return Yup.string();
          //     }
          // }),




        })}
        onSubmit={values => {

          this.setState({ loading: true });
          this.handleUpload(values);
          setTimeout(() => {
            let hasModule = ''
            if (values.hasModules == true) {
              hasModule = 1
            }
            else {
              hasModule = 0
            }
            let isOptional = ''
            if (values.isOptional == true) {
              isOptional = 1
            }
            else {
              isOptional = 0
            }
            let isDisplayinCourseCatalog = ''
            if (values.isDisplayinCourseCatalog == true) {

              isDisplayinCourseCatalog = 1
            }
            else {

              isDisplayinCourseCatalog = 0
            }

            let today = new Date();
            let data = {
              productID: this.state.productID,
              products: this.state.productID,
              productName: values.productName.trim(),
              // Please dont remove localStorage
              productThumbnail: localStorage.getItem('prdthumbnail'),
              productLink: values.productLink.trim(),
              // Please dont remove localStorage
              productVideourl: localStorage.getItem('prdvideourl'),
              partnerPartyID: values.partnerPartyID,
              partner: values.partner,
              partnerID: values.partner,
              isParentProduct: 1,
              parentProductID: values.parentProductID,
              hasModules: hasModule,
              isOptional: isOptional,
              isDisplayinCourseCatalog: isDisplayinCourseCatalog,
              // buid: values.buid,
              productAnchor: values.productAnchor.trim(),
              productSubtitle: values.productSubtitle.trim(),
              productLanguage: values.productLanguage,
              productDescription: values.productDescription.trim(),
              productType: values.productType,
              productCode: values.productCode,
              productPrice: values.productPrice,
              productReattemptPrice: values.reAttemptPrice,
              //isActive: values.status,
              isActive: values.isActive,
              createdBy: localStorage.getItem('userid-Token'),
              createdDate: values.createdDate ? moment(today).format('DD/MM/YYYY HH:mm:ss') : values.createdDate,
              lastModifiedBy: values.lastModifiedBy,
              lastModifiedDate: values.lastModifiedDate,
              productMinPassingScore: values.productMinPassingScore,
              totalScore: values.totalScore,
              //status: values.status,
              productTypeList: values.productTypeList,
              partnerList: values.partnerList,
              statusList: values.statusList,
              modifiedBy: localStorage.getItem('userid-Token'),

              document: values.document,

            };

            ProductService.updateProduct(
              data,
              cb => {
                //console.log("CB", cb.status);

                if (cb.status === "success") {

                  //console.log("CB.STATUS", cb.status);
                  this.setState({ loading: false });
                  success(
                    "Course updated successfully!",
                    successNotification
                  );

                  // Please dont remove localStorage
                  localStorage.setItem('reload', true)
                  this.props.history.push("/course-list");

                } else {

                  this.setState({ loading: false });
                  // error(cb.reasonText, {
                  //   ...errorNotification,
                  //   container: "top-center"
                  // });
                  // warning(cb.reasonText ? cb.reasonText : cb.status, warningNotification);
                  warning(cb.reasonText ? cb.reasonText : cb.status, {
                    ...warningNotification,
                    container: "top-center"
                  })
                }
              },
              err => console.log("Error", err)
            );
          }, 7000);
        }}
        render={({ errors, touched, handleSubmit, handleChange, values, setFieldValue, ...formikProps }) => (
          <React.Fragment>
            {this.state.loading && (
              <PopUpPortal
                HidePopup={this.state.loading}
                IsVisible={this.state.loading}
              />
            )}
            <section class="dashboard-tab user-profile pt-80 mb-80">
              <Form onSubmit={handleSubmit}
                onKeyDown={onKeyDown => {
                  if (
                    (onKeyDown.charCode || onKeyDown.keyCode) ===
                    13 &&
                    onKeyDown.target.name != "productLanguage" &&

                    onKeyDown.target.name != "submitForm" &&
                    onKeyDown.target.name != "cancelForm"
                  ) {
                    onKeyDown.preventDefault();
                  }
                }}
                className="form-group">
                <div class="">
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 pt-130">
                        <div class="bg-box">
                          <section class="create-user" id="create-user">
                            <div class="row">
                              <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <h2 class="sub-header">Course Details</h2>
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Type{" "}
                                        <span className="validation">
                                          {" "}
                                          *
                                            </span>
                                      </label>
                                      <Field
                                        as="select"
                                        name="productType"
                                        id="productType"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productType && touched.productType
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        {<option value="">--Select--</option>}

                                        {this.state.productTypeList ? this.state.productTypeList.map(team => (

                                          <option
                                            key={team.codeValueId}
                                            value={team.codeValueId}
                                          >
                                            {team.codeValue}
                                          </option>
                                        )) : ""}
                                      </Field>
                                      <ErrorMessage
                                        name="productType"
                                        component="div"
                                        className="validation"
                                      />

                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Status{" "}
                                        <span className="validation">
                                          {" "}
                                          *
                                            </span>
                                      </label>
                                      <Field
                                        as="select"
                                        name="isActive"
                                        id="isActive"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.isActive && touched.isActive
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">--Select--</option>
                                        {/* <option value="1">Active</option>
                                        <option value="0">InActive</option> */}
                                        {/* //{this.props.status.map(team => ( */}
                                        {this.state.statusList ? this.state.statusList.map(team => (
                                          <option
                                            key={team.codeValueId}
                                            value={team.codeValueId}
                                          >
                                            {team.codeValue}
                                          </option>
                                        )) : ""}
                                        {/* 
                                {this.state.productTypeList ? this.state.productTypeList.map(team => (
                                                    
                                                    <option
                                                      key={team.codeValueId}
                                                      value={team.codeValueId}
                                                    >
                                                      {team.codeValue}
                                                    </option>
                                                  )) : "" } */}


                                      </Field>
                                      <ErrorMessage
                                        name="isActive"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Name{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="productName"
                                        id="productName"
                                        disabled={true}
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productName &&
                                            touched.productName
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Course Name"
                                      />
                                      <ErrorMessage
                                        name="productName"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Code{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        name="productCode"
                                        id="productCode"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productCode &&
                                            touched.productCode
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Course Code"
                                      />
                                      <ErrorMessage
                                        name="productCode"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Link
                                      </label>
                                      <Field
                                        type="text"
                                        name="productLink"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productLink &&
                                            touched.productLink
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="product Link"
                                      />
                                      <ErrorMessage
                                        name="Course Link"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Partner  {" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        as="select"
                                        name="partner"
                                        id="partner"

                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.partner &&
                                            touched.partner
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">--Select--</option>

                                        {this.props.partner.map(team => (
                                          <option
                                            key={team.partnerID}
                                            value={team.partnerID}
                                          >
                                            {team.partnerName}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="partner"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    {/* <div class="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                          BUID
                                          <span className="validation"> *</span>
                                          </label>
                                        <Field
                                          type="text"
                                          name="buid"
                                          onChange={handleChange}
                                          className={
                                            "form-control" +
                                            (errors.buid &&
                                            touched.buid
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="buid"
                                        />
                                        <ErrorMessage
                                          name="buid"
                                          className="validation"
                                          component="div"
                                        />
                                      </div> */}
                                    {/* <div class="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                        HasModules
                                          <span className="validation"> *</span>
                                        </label>
                                      <Field
                                              className="form-check-input"
                                              type="checkbox"
                                              name="sameAsAbove"
                                              // checked={
                                              //   this.state.checkAddressFlag
                                              // }
                                              // onClick={
                                              //   this.assignPerAddressSameAsCores
                                              // }
                                            />
                                            </div> */}

                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Anchor
                                      </label>
                                      <Field
                                        type="text"
                                        name="productAnchor"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productAnchor &&
                                            touched.productAnchor
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Course Anchor"
                                      />
                                      <ErrorMessage
                                        name="productAnchor"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Subtitle
                                      </label>
                                      <Field
                                        type="text"
                                        name="productSubtitle"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productSubtitle &&
                                            touched.productSubtitle
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Product Subtitle"
                                      />
                                      <ErrorMessage
                                        name="productSubtitle"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Language{" "}
                                      </label>
                                      <Field
                                        as="select"
                                        name="productLanguage"
                                        id="productLanguage"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productLanguage && touched.productLanguage
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">--Select--</option>
                                        {/* {values.productLanguage.map(team => (
                                                <option
                                                  key={team.productLanguageId}
                                                  value={team.productLanguageId}
                                                >
                                                  {team.productLanguage}
                                                </option>
                                              ))} */}
                                        <option value="1">English</option>
                                      </Field>
                                      <ErrorMessage
                                        name="productLanguage"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Price
                                          <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="productPrice"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productPrice &&
                                            touched.productPrice
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Course Price"
                                      />
                                      <ErrorMessage
                                        name="productPrice"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Reattempt Price
                                      </label>
                                      <Field
                                        type="text"
                                        name="reAttemptPrice"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.reAttemptPrice &&
                                            touched.reAttemptPrice
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Reattempt Price"
                                      />
                                      <ErrorMessage
                                        name="reAttemptPrice"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    {/* <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Minimum Passing Score
                                      </label>
                                      <Field
                                        type="text"
                                        name="productMinPassingScore"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productMinPassingScore &&
                                            touched.productMinPassingScore
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Minimum Passing Score"
                                      />
                                      <ErrorMessage
                                        name="productMinPassingScore"
                                        className="validation"
                                        component="div"
                                      />
                                    </div> */}
                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Total Score
                                      </label>
                                      <Field
                                        type="text"
                                        name="totalScore"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.totalScore &&
                                            touched.totalScore
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Total Score"
                                      />
                                      <ErrorMessage
                                        name="totalScore"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div class="col-md-4 col-sm-6 col-xs-12">

                                      <Field
                                        type="checkbox"
                                        name="isDisplayinCourseCatalog"
                                      />
                                      <label >&nbsp; Visible</label>
                                      <div className="form-field-error">{errors.isDisplayinCourseCatalog}</div>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12">

                                      <Field
                                        type="checkbox"
                                        name="hasModules"
                                        onChange={handleChange}
                                      />
                                      <label > &nbsp; Modules</label>
                                      <div className="form-field-error">{errors.hasModules}</div>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12">

                                      <Field
                                        type="checkbox"
                                        name="isOptional"
                                        onChange={handleChange}
                                        checked={values.isOptional}
                                        onClick={
                                          e => {
                                            if (e.target.checked == true) {
                                              setFieldValue(values.isOptional = false)
                                            } else {
                                              setFieldValue(values.isOptional = true)
                                            }
                                          }
                                        }


                                      />
                                      <label > &nbsp; Is Optional </label>
                                      <div className="form-field-error">{errors.isOptional}</div>
                                    </div>
                                    {/* <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Product Thumbnail{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="productThumbnail"
                                        id="productThumbnail"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productThumbnail && touched.productThumbnail
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Product Thumbnail"
                                      />
                                      <ErrorMessage
                                        name="productThumbnail"
                                        className="validation"
                                        component="div"
                                      />
                                    </div> */}
                                  </div>
                                  <div className="row">
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Thumbnail</label>
                                      <div className="profile-detail">
                                        <div className="circle">
                                          <img
                                            className="profile-pic"
                                            src={values.productThumbnail}
                                          />
                                          <div className="profile">
                                            <i
                                              className="fa fa-user"
                                              aria-hidden="true"
                                            ></i>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="profile-add">
                                        <span className="icon btn-file text-center">
                                          <i
                                            className="fa fa-plus-circle"
                                            aria-hidden="true"
                                          ></i>
                                          <FileBase64
                                            multiple={true}
                                            onChange={handleChange}
                                            onDone={event => {
                                              if (
                                                [
                                                  "image/jpg",
                                                  "image/jpeg",
                                                  "image/png"
                                                ].indexOf(event[0].type) < 0
                                              ) {
                                                setFieldValue((values.documentTypeCheckForProductTImage = true));
                                              } else if (
                                                event[0].file.size <= 5000000
                                              ) {

                                                values.document.push({
                                                  documentHash: event[0].base64,
                                                  documentType: "ProductThumbNail",
                                                  documentName: event[0].name.split('.')[0] + ".png"
                                                });

                                                setFieldValue((values.documentTypeCheckForProductImage = false));
                                                setFieldValue((values.documentSizeCheckForProductCheck = false));
                                                values.productThumbnail = event[0].base64;
                                                setFieldValue((values.productThumbnail = event[0].base64));

                                              } else {
                                                setFieldValue(
                                                  (values.documentSizeCheckForProductCheck = true)
                                                );
                                              }
                                              //alert("Base64 is ---- " + JSON.stringify(event[0].base64))
                                            }
                                            }
                                          />
                                        </span>
                                        <h4 >Add Image</h4>
                                        <div className="col-md-12 col-sm-12">
                                          <span class="file-size-limit">
                                            Supported Formats: .jpg, .jpeg, .png
                                          only. <br />
                                            File Size: Max 5 MB
                                        </span>
                                        </div>
                                        {values.documentSizeCheckForProductCheck ? (
                                          <p style={{ color: "red" }}>
                                            File Size is too large(Maximum File
                                            Size:5MB).
                                          </p>
                                        ) : (
                                            ""
                                          )}
                                        {values.documentTypeCheckForProductImage ? (
                                          <p style={{ color: "red" }}>
                                            Invalid image format
                                          </p>
                                        ) : (
                                            ""
                                          )}
                                      </div>
                                    </div>
                                    {/* <div class="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Product Videourl
                                          <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="productVideourl"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productVideourl &&
                                            touched.productVideourl
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Product Videourl"
                                      />
                                      <ErrorMessage
                                        name="productVideourl"
                                        className="validation"
                                        component="div"
                                      />
                                    </div> */}
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label> Video url</label>
                                      <div className="profile-detail">
                                        <div className="circle">
                                          <div className="profile-pic">
                                            <div className="profile">
                                              <ReactPlayer
                                                url={values.productVideourl}
                                                // playing
                                                controls
                                                autoPlay
                                              ></ReactPlayer>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="profile-add">
                                          <span className="icon btn-file text-center">
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            ></i>
                                            <FileBase64
                                              multiple={true}
                                              name="productVideourl"
                                              onChange={handleChange}
                                              onDone={event => {

                                                if (
                                                  [
                                                    "video/mp4",
                                                    "video/avi",
                                                    "video/mpeg"
                                                  ].indexOf(event[0].type) < 0
                                                ) {
                                                  setFieldValue(
                                                    (values.documentTypeCheckForVideo = true)
                                                  );
                                                } else if (
                                                  event[0].file.size <= 10000000
                                                ) {

                                                  values.document.push({
                                                    documentHash: event[0].base64,
                                                    documentType: "ProductVideourl",
                                                    documentName: event[0].name
                                                  });
                                                  //alert('base64 is : ', JSON.stringify(event[0].base64))
                                                  setFieldValue((values.documentTypeCheckForVideo = false));
                                                  setFieldValue((values.documentSizeCheckForVideoCheck = false));
                                                  setFieldValue((values.productVideourl = event[0].base64));
                                                } else {
                                                  setFieldValue((values.documentSizeCheckForVideoCheck = true));
                                                }
                                              }}
                                            />
                                          </span>
                                          <h4>Add Video</h4>

                                          {values.documentSizeCheckForVideoCheck ? (
                                            <p style={{ color: "red" }}>
                                              File Size is too large(Maximum File
                                              Size:10MB).
                                            </p>
                                          ) : (
                                              ""
                                            )}
                                          {values.documentTypeCheckForVideo ? (
                                            <p style={{ color: "red" }}>
                                              Invalid Format
                                            </p>
                                          ) : (
                                              ""
                                            )}
                                          <div className="col-md-12 col-sm-12">
                                            <span class="file-size-limit">
                                              Supported Formats: .mp4, .avi, .mpeg
                                            only. <br />
                                              File Size: Max 10 MB
                                          </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4 col-sm-6">
                                      <div className="form-group">
                                        <label>Description</label>
                                        <textarea rows="8" cols="50"
                                          name="productDescription"
                                          id="productDescription"
                                          value={values.productDescription}
                                          onChange={handleChange}
                                          autoComplete="productDescription"
                                          className={
                                            "form-control" +
                                            (errors.productDescription && touched.productDescription
                                              ? " is-invalid"
                                              : "")
                                          }
                                        />
                                        <ErrorMessage
                                          name="productDescription"
                                          className="validation"
                                          component="div"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>

                          <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-20">

                            <button
                              type="submit"
                              name="submitForm"
                              class="btn-4 pull-right"
                              onClick={async () => {
                                const curErrors = await formikProps.validateForm();
                                const curErrorsKeys = Object.keys(
                                  curErrors
                                );

                                if (curErrorsKeys.length) {
                                  // Assuming curErrorsKeys[0] identifies the first failing field, use that to
                                  // find the correct DOM element to call .focus() on.
                                  //
                                  // Since I set the id attribute on all my form's <input>s to match the error
                                  // keys, I just use document.getElementById(), but of course you could use refs
                                  const el = document.getElementById(
                                    curErrorsKeys[0]
                                  );

                                  if (el) el.focus();
                                }
                              }}
                            >
                              Submit
                                </button>

                            <a>
                              <button
                                type="button"
                                name="cancelForm"
                                class="btn-4 mr-20 pull-right"
                                onClick={this.handleCancel}
                              >
                                Cancel
                                </button>
                            </a>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </section>



          </React.Fragment>
        )}
      />

    );
  }
}

export default EditProduct;
